import React from "react";
import styles from "./modal-add-item.module.css";
import { Modal } from "antd";
import { Select } from "antd";
import { IParagraph } from "../../../interfaces/insightPost";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faUpload } from "@fortawesome/free-solid-svg-icons";

interface ModalAddItemProps {
  visible: boolean;
  onCreate: (values: any) => void;
  onCancel: () => void;
}

const ModalAddItem: React.FC<ModalAddItemProps> = ({
  visible,
  onCreate,
  onCancel,
}) => {
  const [newParagraph, setNewParagraph] = React.useState<IParagraph>({});
  const { Option } = Select;

  return (
    <Modal
      open={visible}
      title="Novo item"
      okText="Adicionar"
      onOk={() => {
        onCreate(newParagraph);
        setNewParagraph({});
      }}
      cancelText="Cancelar"
      onCancel={onCancel}
      width="60%"
      okButtonProps={{
        style: { backgroundColor: "#135c31", color: "white", fontWeight: 500 },
      }}
      cancelButtonProps={{
        style: { backgroundColor: "white", color: "#135c31", fontWeight: 500 },
      }}
    >
      <Select
        placeholder="Select type"
        className={styles.select}
        value={newParagraph.type}
        onChange={(e) => setNewParagraph({ type: e })}
      >
        <Option value="text">Texto</Option>
        <Option value="list">Lista</Option>
        <Option value="image">Imagem</Option>
        <Option value="video">Video</Option>
        <Option value="link">Link</Option>
      </Select>
      {newParagraph.type === "text" && (
        <div className={`${styles.form_input_div} ${styles.w100}`}>
          <label htmlFor="title" className={styles.form_label}>
            Digite o parágrafo:
          </label>
          <textarea
            className={styles.textarea}
            id="title"
            rows={12}
            onChange={(e) =>
              setNewParagraph({ ...newParagraph, text: e.target.value })
            }
          />
        </div>
      )}
      {newParagraph.type === "list" && (
        <div className={`${styles.gap}`}>
          <div className={`${styles.form_input_div} ${styles.w100}`}>
            <label htmlFor="textArea" className={styles.form_label}>
              Texto inicial:
            </label>
            <textarea
              className={styles.textarea}
              rows={4}
              id="textArea"
              onChange={(e) =>
                setNewParagraph({ ...newParagraph, text: e.target.value })
              }
            />
          </div>
          <div className={`${styles.form_input_horizontal_div}`}>
            <label htmlFor="listNumber" className={styles.form_label}>
              Número de itens:
            </label>
            <input
              type="number"
              className={styles.list_number}
              id="listNumber"
              onChange={(e) => {
                const numberOfLines = parseInt(e.target.value, 10);
                setNewParagraph({
                  ...newParagraph,
                  list: Array(numberOfLines).fill(""),
                });
              }}
            />
          </div>

          {newParagraph.list &&
            newParagraph.list.map((item, index) => (
              <div
                key={index}
                className={`${styles.form_input_horizontal_div}`}
              >
                <label
                  htmlFor={`listItem${index}`}
                  className={styles.item_label}
                >{`Item ${index}:`}</label>
                <input
                  type="text"
                  id={`listItem${index}`}
                  className={styles.list_item}
                  onBlur={(e) => {
                    const newList = [...(newParagraph.list || [])];
                    newList[index] = e.target.value;
                    setNewParagraph({ ...newParagraph, list: newList });
                  }}
                />
              </div>
            ))}
        </div>
      )}
      {newParagraph.type === "image" && (
        <>
          <span className={styles.form_label_left}>Capa:</span>
          <div className={styles.form_image_upload}>
            {newParagraph?.text ? (
              <button
                className={styles.upload_img_btn}
                onClick={() => {
                  setNewParagraph({ ...newParagraph, text: "" });
                  (document.getElementById("img") as HTMLInputElement).value =
                    "";
                }}
              >
                <span>Remover</span>
                <FontAwesomeIcon icon={faTrash} size="sm" />
              </button>
            ) : (
              <label htmlFor="img" className={styles.upload_img_btn}>
                <span>Upload</span>
                <FontAwesomeIcon icon={faUpload} size="sm" />
              </label>
            )}
            <input
              type="file"
              id="img"
              className={styles.form_input_img}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (e.target.files && e.target.files[0]) {
                  const reader = new FileReader();
                  reader.onload = (event) => {
                    setNewParagraph({
                      ...newParagraph,
                      file: e.target.files ? e.target.files[0] : null,
                      text: event.target?.result as string,
                    });
                  };
                  reader.readAsDataURL(e.target.files[0]);
                }
              }}
            />
            <span className={`${styles.img_input} ${styles.w70}`}>
              {newParagraph?.text
                ? (document.getElementById("img") as HTMLInputElement)
                    ?.files?.[0]?.name
                : "Nenhuma imagem selecionada"}
            </span>
          </div>
          {newParagraph?.text && (
            <div className={`${styles.img_preview_div} ${styles.w100}`}>
              <img
                className={styles.img_preview}
                src={newParagraph.text}
                alt=""
              />
            </div>
          )}
        </>
      )}
      {newParagraph.type === "link" && (
        <div className={`${styles.gap}`}>
          <div className={`${styles.form_input_div} ${styles.w100}`}>
            <label htmlFor="title" className={styles.form_label}>
              Texto inicial:
            </label>
            <textarea
              className={styles.textarea}
              id="textArea"
              rows={2}
              onChange={(e) =>
                setNewParagraph({ ...newParagraph, text: e.target.value })
              }
            />
          </div>
          <div className={`${styles.form_input_div} ${styles.w100}`}>
            <label htmlFor="title" className={styles.form_label}>
              Insira a URL:
            </label>
            <input
              type="text"
              className={styles.input_url}
              onChange={(e) =>
                setNewParagraph({ ...newParagraph, link: e.target.value })
              }
            />
          </div>
        </div>
      )}
      {newParagraph.type === "video" && (
        <div className={`${styles.form_input_div} ${styles.w100}`}>
          <label htmlFor="url" className={styles.form_label}>
            Link do Youtube:
          </label>
          <input
            className={styles.textarea}
            id="url"
            type="text"
            onChange={(e) =>
              setNewParagraph({ ...newParagraph, text: e.target.value })
            }
          />
        </div>
      )}
    </Modal>
  );
};

export default ModalAddItem;
